module.exports = __webpack_public_path__ + "/login_ui/img/kp-38ef4888ea0f288764f4a3d1984078ec.svg";